import { isPlatformBrowser } from '@angular/common';
import { WebSiteUsersService } from './../../../services/webSiteUsers/webSiteUsers.service';
import { PdvService } from './../../../services/pdv/pdv.service';
import { Subscription } from 'rxjs';
import { Component, ViewChild, ElementRef, OnDestroy, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { FamilyService } from '@app/services/family/family.service';
@Component({
    selector: 'footer-component',
    templateUrl: 'footer.component.html',
    styleUrls: ['footer.component.scss'],
    providers:[FamilyService]
})
export class FooterComponent implements OnDestroy, OnInit {
    pdv: any = {};
    subscriptions: Subscription[] = [];
    email = '';
    loading = false;
    authorizedCities: any[] = [];
    displayAll: boolean = false;
    families: any[] = [];
    @ViewChild('maplink') maplink: ElementRef;
    bounceOn: boolean = false;
    currentYear:number;

    constructor(
        private pdvService: PdvService,
        private familyService:FamilyService,
        private webs: WebSiteUsersService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {

        let currentYear=new Date();
        this.currentYear=currentYear.getFullYear()
        
    }
    ngOnDestroy() {
        this.unsubscribe();
    }

    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }

    ngOnInit() {
        const subs2 = this.pdvService.pdv.subscribe(
            pdv => {
                this.pdv = pdv;
            }
        );
        const subs3 = this.pdvService.getAuthorizedCities().subscribe(
            (authorizedCities: any[]) => {
                this.authorizedCities = authorizedCities;
            }
        );
        this.subscriptions.push(subs2, subs3);
        this.getFamiliesOfCarte();
        setTimeout(
            () => {
                let coords = this.pdv.address;
                if (coords) {
                    coords = coords.replace(/\ /g, '+');
                    this.maplink.nativeElement.setAttribute('href', this.GetMapUrl(coords));
                }
            }, 1000
        );
    }

    GetMapUrl(q) {
        if (isPlatformBrowser(this.platformId)) {
            const ua = navigator.userAgent.toLowerCase();
            const windows8 = ua.indexOf('windows nt 6.2') > -1;
            const mobile = ua.indexOf('mobile') > -1 || ua.indexOf('wp7') > -1;
            const iPhone = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1;
            const android = ua.indexOf('android') > -1;
            const msie = ua.indexOf('msie') > -1;
            if (mobile && iPhone) { return ('http://maps.google.com/maps?q=' + q); } else if (mobile && android) { return ('geo:0,0?q=' + q); } else if (mobile && msie) { return ('maps:' + q); } else if (windows8) { return ('bingmaps:?q=' + q); } else {
                return ('http://maps.google.com/maps?q=' + q);
            }
        }
    }
    bounceOnFunction() {
        this.bounceOn = true;
        setTimeout(() => {
            this.bounceOn = false;
        }, 500)
    }

    getFamiliesOfCarte() {
        this.familyService.getFamiliesOfCarte().subscribe(
            (families: any[]) => {
                this.families = families;
            }
        )
    }

}
